import {
  PostStatus,
  Post,
  SearchEntity,
  Space,
  Member,
  SpaceType,
  MemberStatus,
  ExternalSearchResult,
} from '@tribeplatform/gql-client/types'

import { getSearchItemLink } from '../../../Search/utils.js'

export const mapHitToSmartSearchPost = (hit: SearchEntity): Post => ({
  attachmentIds: [],
  createdAt: hit.created,
  publishedAt: hit.created,
  createdById: hit?.by?.id,
  embedIds: [],
  hasMoreContent: true,
  id: hit.id,
  imageIds: [],
  isAnonymous: false,
  locked: false,
  mentionedMembers: [],
  networkId: hit?.in?.networkId,
  ownerId: hit?.by?.id,
  pinnedInto: [],
  postTypeId: hit.entityType,
  reactionsCount: 0,
  repliesCount: 0,
  seoDetail: null,
  spaceId: hit?.in?.id,
  status: PostStatus.PUBLISHED,
  topRepliers: [],
  totalRepliesCount: 0,
  updatedAt: hit.entity.updatedAt,
  title: hit.title,
  description: hit.content,
  owner: {
    member: {
      id: hit?.by?.id,
      name: hit?.by?.name,
      profilePicture: hit?.by?.profilePicture,
      attributes: { locale: '' },
      createdAt: '',
      flagged: false,
      locale: '',
      networkId: '',
      roleId: '',
      status: MemberStatus.DELETED,
      teammate: false,
      updatedAt: '',
      username: '',
    },
  },
  url: getSearchItemLink(hit),
})

export const mapHitToSmartSearchSpace = (hit: SearchEntity): Space => ({
  id: hit.id,
  name: hit?.title,
  description: hit?.content,
  createdAt: hit?.created,
  createdById: hit?.by?.id,
  networkId: hit?.in?.networkId,
  address: { editable: false, exact: false, path: '' },
  customOrderingIndexInGroup: 0,
  highlightedTagIds: [],
  key: '',
  layout: '',
  membersCount: 0,
  slug: '',
  type: SpaceType.Broadcast,
  updatedAt: '',
  image: hit?.media,
  url: getSearchItemLink(hit),
})

export const mapHitToSmartSearchMember = (hit: SearchEntity): Member => ({
  id: hit.id,
  name: hit?.title,
  createdAt: hit?.created,
  flagged: false,
  locale: 'en',
  networkId: hit?.in?.networkId,
  attributes: { locale: 'en' },
  roleId: '',
  status: MemberStatus.VERIFIED,
  teammate: false,
  updatedAt: '',
  username: '',
  profilePicture: hit?.media,
  url: getSearchItemLink(hit),
})

export const mapHitToSmartSearchExternal = (
  hit: SearchEntity,
): ExternalSearchResult => ({
  id: hit.id,
  title: hit.title,
  description: hit.content,
  url: getSearchItemLink(hit),
})
